module.exports = __webpack_public_path__ + "static/media/schedulePatients.5742f775.svg";